import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Textfield from "../Input/Textfield";
import usePosOrderUser from "@/shared/atoms/usePosOrderUser";

const Neighborhood = () => {
  const { t } = useTranslation();
  const { register } = useFormContext();
  const [orderUser] = usePosOrderUser();

  return (
    <Textfield
      ref={register({})}
      defaultValue={orderUser?.neighborhood}
      label={t("posOrders.neighborhood")}
      name="order_user.neighborhood"
    />
  );
};

export default Neighborhood;
